import { app } from '../../../../app';
import { Controller } from './add-saaspass-connect.controller';

app.component('addSaaspassConnect', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./add-saaspass-connect.html'),
});
 


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/add-saaspass-connect/add-saaspass-connect.component.js